var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArea = function SvgArea(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.48517 18.3332H3.18214C2.76548 18.3332 2.40879 18.17 2.11207 17.8436C1.81535 17.5172 1.66699 17.1248 1.66699 16.6665V11.6665H3.18214V16.6665H8.48517V18.3332ZM11.5155 18.3332V16.6665H16.8185V11.6665H18.3337V16.6665C18.3337 17.1248 18.1853 17.5172 17.8886 17.8436C17.5919 18.17 17.2352 18.3332 16.8185 18.3332H11.5155ZM1.66699 8.33317V3.33317C1.66699 2.87484 1.81535 2.48248 2.11207 2.15609C2.40879 1.8297 2.76548 1.6665 3.18214 1.6665H8.48517V3.33317H3.18214V8.33317H1.66699ZM16.8185 8.33317V3.33317H11.5155V1.6665H16.8185C17.2352 1.6665 17.5919 1.8297 17.8886 2.15609C18.1853 2.48248 18.3337 2.87484 18.3337 3.33317V8.33317H16.8185Z",
    fill: "white"
  }))));
};
export { SvgArea as ReactComponent };
export default __webpack_public_path__ + "assets/678e47d2.svg";